module.exports = __webpack_public_path__ + "img/plus-icon.00b42c73.svg";